// b64 payload `v4#{alarm_uuid}#{origin_type}#{origin_uuid}` (older links omit the type);
// null for V3 tokens. Only the two ids go into `GET /v1/public/alarms/{alarm}/{origin}`.
export function parseV4PublicAlarmToken(token) {
    if (!token) return null;
    let decoded;
    try {
        decoded = atob(token);
    } catch (_) {
        return null;
    }
    if (!decoded.startsWith('v4#')) return null;
    const parts = decoded.split('#');
    if (parts.length !== 3 && parts.length !== 4) return null;
    const alarmUuid = parts[1];
    const originUuid = parts[parts.length - 1];
    if (!alarmUuid || !originUuid) return null;
    return { alarmUuid, originUuid };
}
